import { BinIcon, IconWrap } from '@libs/ui/ds'
import { cva } from 'class-variance-authority'
import type { FC } from 'react'
import React, { forwardRef } from 'react'

type Props = {
  highlight?: boolean
  show?: boolean
  ref?: React.Ref<HTMLDivElement>
}

const deleteZoneCVA = cva(
  [
    'fixed bottom-0 z-50 flex w-full items-center justify-center bg-semantic-red-500  py-5 text-neutral-50'
  ],
  {
    variants: {
      show: {
        true: 'translate-y-0 duration-300',
        false: 'translate-y-full'
      },
      highlight: {
        true: 'opacity-100 duration-300',
        false: 'opacity-70'
      }
    }
  }
)

export const DeleteZone: FC<Props> = forwardRef(({ show, highlight }, ref) => {
  return (
    <div ref={ref}>
      <div className={deleteZoneCVA({ show, highlight })}>
        <IconWrap icon={<BinIcon />} size='l' />
      </div>
    </div>
  )
})
DeleteZone.displayName = 'DeleteZone'
